@if(isMigrated){
    <pdp-redesign></pdp-redesign>
} @else {
    <app-pdp></app-pdp>
}